import { render, staticRenderFns } from "./WorkerDetailsPopup.vue?vue&type=template&id=08a831c7&scoped=true"
import script from "./WorkerDetailsPopup.vue?vue&type=script&lang=js"
export * from "./WorkerDetailsPopup.vue?vue&type=script&lang=js"
import style0 from "./WorkerDetailsPopup.vue?vue&type=style&index=0&id=08a831c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a831c7",
  null
  
)

export default component.exports